import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/Store";
import "./index.css";
import "./globalStyle.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { initHighchartsModules } from "./utils/initHighchartsModules";

<link
  href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
  rel="stylesheet"
></link>;
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

initHighchartsModules();

root.render(
  <React.StrictMode>
    <HashRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </HashRouter>
  </React.StrictMode>
);
